"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.veYETIStake = void 0;
const Decimal_1 = require("./Decimal");
/**
 * Represents the change between two states of a veYETI Stake.
 *
 * @public
 */
class veYETIStake {
    /** @internal */
    constructor(yetiStake = Decimal_1.Decimal.ZERO, veYETIGain = Decimal_1.Decimal.ZERO, veYETITotal = Decimal_1.Decimal.ZERO) {
        this.yetiStake = yetiStake;
        this.veYETIGain = veYETIGain;
        this.veYETITotal = veYETITotal;
    }
    get isEmpty() {
        return this.yetiStake.isZero && this.veYETIGain.isZero && this.veYETITotal.isZero;
    }
    /**
       * Compare to another instance of `YETIStake`.
       */
    equals(that) {
        return (this.yetiStake.eq(that.yetiStake) &&
            this.veYETIGain.eq(that.veYETIGain) &&
            this.veYETITotal.eq(that.veYETITotal));
    }
}
exports.veYETIStake = veYETIStake;
//# sourceMappingURL=veYETIStake.js.map